import React from 'react';
import createEditor from '../form/ComponentEditor';
import {PromotionEditor} from "./PromotionEditor";

export default createEditor({
    componentName: "PackagePromotion",
    WrappedComponent: PromotionEditor,
    props: {
        listHeader: "Csomag kedvezmények",
        editorHeader: "Csomag kedvezmény",
        type: "packagepromotion",
        listFilter: [{
            field: "type", value: "packagepromotion"
        }],
        componentActions: (action, data, params) => {
            data.type = "packagepromotion";
            return {action,data,params};
        }
    }
});
